<template>
  <a-card :bordered="false">
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        新增
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="onEdit(record)">编辑</a>
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import UserModal from './components/UserModal';
import { tableListMixin } from "@/mixins";
import { workExpriseInfo } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "公司名称", dataIndex: "companyName", key: "companyName" },
  { title: '职位名称', dataIndex: "jobTitleName", key: "jobTitleName" },
  { title: '入职时间', dataIndex: "timeEntry", key: "timeEntry" },
  { title: '离职时间', dataIndex: "timeDeparture", key: "timeDeparture" },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: {
    UserModal
  },
  data() {
    return {
      dateFormat,
      columns,
      queryParam: {},
      listUrl: workExpriseInfo.pageList,
      listKeyField: "id",
      deleteUrl: workExpriseInfo.remove,
      editUrl: workExpriseInfo.saveupdate,
    }
  },
  methods: {
    onAdd() {
      this.onShowModal('userModal');
    },
    onEdit(record) {
      this.getAction({
        url: workExpriseInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('userModal', res);
      })
    },
    onDetail(record) {
      this.getAction({
        url: workExpriseInfo.detail,
        params: { id: record.id }
      }).then(res => {
        this.onShowModal('detailModal', res);
      })
    },
  }
}
</script>

<style scoped></style>
